import { Module, ActionContext } from 'vuex'
import { ConversationAiState, RootState } from '../store/state_models'
import { PRODUCT_CODE } from '../util/branded_app_helper'
import config from '../config/index'
import createResellingService from '../services/ResellingService'

// Use the factory function instead of instantiating a class
const resellingService = createResellingService(config.resellingBaseUrl, PRODUCT_CODE)

function getInitialData(): any {
  return {
    subscriptionPeriod: 'month',
    offeringEnabled: false,
    amount: 0,
  }
}
export const clientPortal: Module<RootState> = {
  namespaced: true,
  state: getInitialData(),
  getters: {
    isBrandedAppEnabled: (state: any) => {
      return {
        offeringEnabled: state.offeringEnabled,
      }
    },
  },
  mutations: {
    setOfferingEnabled(state, enabled) {
      state.offeringEnabled = enabled
    },
    setAmount(state, amount) {
      state.amount = amount
    },
  },
  actions: {
    async getProduct() {
      try {
        const res = await resellingService.getProductConfiguration()
        return Promise.resolve(res)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getCompanySubscriptions(context: ActionContext<RootState>) {
      try {
        const companyId = context.rootState?.company.company.id as string
        const res = await resellingService.getCompanySubscriptions(companyId)

        const locationSubscriptions = res.filter(item => item.productCode === PRODUCT_CODE)
        return Promise.resolve(locationSubscriptions)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getLocationSubscriptions(context: ActionContext<ConversationAiState, RootState>) {
      try {
        const locationId = context.rootState?.locations.currentLocation.id as string
        const res = await resellingService.getLocationSubscriptions(locationId)
        const locationSubscriptions = res.filter((item) => item.productCode === PRODUCT_CODE && item.paymentStatus == PRODUCT_CODE)

        return Promise.resolve(locationSubscriptions)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getLocationConfiguration(
      context: ActionContext<ConversationAiState, RootState>,
      payload: { locationId: string }
    ) {
      try {
        const res = await resellingService.getLocationResellingConfiguration(payload.locationId)

        this.commit('clientPortal/setOfferingEnabled', res.offeringEnabled)
        this.commit('clientPortal/setAmount', res.amount)
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
